<template>
  <section class="care-section" :id="sectionId">
    <p class="section-eyebrow">{{ eyebrow }}</p>
    <h2 class="section-title">{{ title }}</h2>
    <slot />
  </section>
</template>

<script>
export default {
  name: "CareSection",
  props: {
    sectionId: {
      type: String,
      required: true,
    },
    eyebrow: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
